import { Outlet } from 'react-router-dom';

export const DisplayLayout = () => {
  return <Outlet />;
};
